// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { dataSanitizeMeasurements, dataSanitizeProperties, dataSanitizeString, dataSanitizeUrl, msToTimeSpan, urlParseUrl } from "@microsoft/applicationinsights-core-js";
import { _DYN_DATA, _DYN_LENGTH, _DYN_NAME } from "../__DynamicConstants";
export var RemoteDependencyEnvelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
    var target, name = commandName, data = commandName;
    if (absoluteUrl && absoluteUrl[_DYN_LENGTH /* @min:%2elength */] > 0) {
        var parsedUrl = urlParseUrl(absoluteUrl);
        target = parsedUrl.host;
        if (!name) {
            if (parsedUrl.pathname != null) {
                var pathName = (parsedUrl.pathname[_DYN_LENGTH /* @min:%2elength */] === 0) ? "/" : parsedUrl.pathname;
                if (pathName.charAt(0) !== "/") {
                    pathName = "/" + pathName;
                }
                data = parsedUrl.pathname;
                name = dataSanitizeString(logger, method ? method + " " + pathName : pathName);
            }
            else {
                name = dataSanitizeString(logger, absoluteUrl);
            }
        }
    }
    else {
        target = commandName;
        name = commandName;
    }
    return {
        target: target,
        name: name,
        data: data
    };
}
export function createRemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
    if (requestAPI === void 0) { requestAPI = "Ajax"; }
    var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
    var data = {
        ver: 2,
        id: id,
        duration: msToTimeSpan(value),
        success: success,
        resultCode: "" + resultCode,
        type: dataSanitizeString(logger, requestAPI),
        data: dataSanitizeUrl(logger, commandName) || dependencyFields[_DYN_DATA /* @min:%2edata */],
        target: dataSanitizeString(logger, dependencyFields.target),
        name: dataSanitizeString(logger, dependencyFields[_DYN_NAME /* @min:%2ename */]),
        properties: dataSanitizeProperties(logger, properties),
        measurements: dataSanitizeMeasurements(logger, measurements),
        aiDataContract: {
            id: 1 /* FieldType.Required */,
            ver: 1 /* FieldType.Required */,
            name: 0 /* FieldType.Default */,
            resultCode: 0 /* FieldType.Default */,
            duration: 0 /* FieldType.Default */,
            success: 0 /* FieldType.Default */,
            data: 0 /* FieldType.Default */,
            target: 0 /* FieldType.Default */,
            type: 0 /* FieldType.Default */,
            properties: 0 /* FieldType.Default */,
            measurements: 0 /* FieldType.Default */,
            kind: 0 /* FieldType.Default */,
            value: 0 /* FieldType.Default */,
            count: 0 /* FieldType.Default */,
            min: 0 /* FieldType.Default */,
            max: 0 /* FieldType.Default */,
            stdDev: 0 /* FieldType.Default */,
            dependencyKind: 0 /* FieldType.Default */,
            dependencySource: 0 /* FieldType.Default */,
            commandName: 0 /* FieldType.Default */,
            dependencyTypeName: 0 /* FieldType.Default */
        }
    };
    if (correlationContext) {
        data.target = "" + data.target + " | " + correlationContext;
    }
    return data;
}
//# sourceMappingURL=RemoteDependencyData.js.map